/**
 * KISSED Clinic OS — Public website link inventory & theme.
 *
 * EXTERNAL = working links carried over from the live KissedFunctionalWellness.com
 *            site (Square hosted checkout / booking). Preserved as-is per Phase 2C.
 *            These are Square-HOSTED pages, NOT the Clinic OS Square API (which stays
 *            isolated per Phase 2A). Do not wire these into the backend.
 *
 * ROUTES   = internal Clinic OS routes that public CTAs map to (reused, not rebuilt).
 */

export const EXTERNAL = {
  // Paid Functional Wellness assessment tiers (Square hosted checkout)
  squareTierIntro: "https://square.link/u/GpmfD1CB",      // KISSED Wellness Assessment Intro $47
  squareTierStandard: "https://square.link/u/CExloeMP",   // KISSED Wellness Assessment Standard $147
  squareTierPremium: "https://square.link/u/0Gs2lAkw",    // KISSED Wellness Assessment Premium $297
  // In-person booking (Square Appointments hosted)
  bookInPersonWellness: "https://book.squareup.com/appointments/1aubtqkk1rvlv3/location/2WZDAQVBX8ADX/services",
  bookHairScalpAnalysis: "https://book.squareup.com/appointments/czf11kwwy253u9/location/2WZDAQVBX8ADX/services",
  bookHairInvestigation: "https://book.squareup.com/appointments/1aubtqkk1rvlv3/location/2WZDAQVBX8ADX/services",
  // Existing-client salon services reuse the general Square Appointments menu.
  bookExistingClientServices: "https://book.squareup.com/appointments/037am6afc9z7rn/location/2WZDAQVBX8ADX/services",
};

// Internal Clinic OS routes (reused existing screens)
export const ROUTES = {
  home: "/",
  hairScalp: "/hair-scalp",
  wellness: "/wellness",
  programs: "/programs",
  services: "/in-clinic-services",
  about: "/about",
  startHere: "/start-here",
  navigator: "/navigator",
  shop: "/shop",
  cart: "/cart",
  // existing assessment / portal / auth routes
  wellnessAssessment: "/wellness-assessment",
  deepDive: "/clinic/deep-dive",
  intake: "/intake",
  clientLogin: "/client/login",
  checkin: "/checkin",
  adminLogin: "/admin/login",
};

// Brand palette reproduced from the live site
export const C = {
  ink: "#1F1A26",
  plum: "#2E1245",      // dark nav / footer
  primary: "#4A1D5E",   // primary button / brand purple
  accent: "#8A4FB8",    // italic accent / eyebrow
  lavender: "#CBB8E6",
  lightBg: "#F7F3FB",
  green: "#3E9B7A",
  line: "#EADFF3",
};

export const SERIF = { fontFamily: "'Fraunces', Georgia, 'Times New Roman', serif" };
